import { brightness } from './brightness';
import fromString from './fromString';
import { toHEX, toRGBA, toHSVA } from './toString';
export default class Color {
  constructor(input) {
    var x = typeof input === 'string' ? fromString(input) : input;
    if (x === undefined) {
      this.red = 0;
      this.green = 0;
      this.blue = 0;
      this.alpha = 0;
      return;
    }
    this.red = x[0];
    this.green = x[1];
    this.blue = x[2];
    this.alpha = x[3] === undefined ? 1 : x[3];
  }
  brightness() {
    return brightness(this.red, this.green, this.blue, this.alpha);
  }
  toHEX() {
    return toHEX(this.red, this.green, this.blue);
  }
  inspect() {
    return toRGBA(this.red, this.green, this.blue, this.alpha);
  }
  toArray() {
    return [this.red, this.green, this.blue, this.alpha];
  }
  toRGBA() {
    return toRGBA(this.red, this.green, this.blue, this.alpha);
  }
  toHSVA() {
    return toHSVA(this.red, this.green, this.blue, this.alpha);
  }
  toString() {
    return toRGBA(this.red, this.green, this.blue, this.alpha);
  }
  withAlpha(alpha) {
    return Color.of(this.red, this.green, this.blue, alpha);
  }
  invert() {
    var invertColor = color => 255 - color;
    return Color.of(invertColor(this.red), invertColor(this.green), invertColor(this.blue), this.alpha);
  }
  static of() {
    var red = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var green = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var blue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    return new Color([red, green, blue, alpha]);
  }
}
//# sourceMappingURL=index.js.map